/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {Namespace} from '../models/Namespace';

export interface GetAllNamespaces$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAllNamespacesRequest = createAction<PayloadData<void>>('ENTITLEMENT_NAMESPACES__GET_ALL_NAMESPACES__REQUEST');
export const getAllNamespacesSuccess = createAction<PayloadData<Array<Namespace>>>('ENTITLEMENT_NAMESPACES__GET_ALL_NAMESPACES__SUCCESS');
export const getAllNamespacesFailure = createAction<PayloadData<Error, void, true>>('ENTITLEMENT_NAMESPACES__GET_ALL_NAMESPACES__FAILURE');

export const getAllNamespacesActions = [
    getAllNamespacesRequest,
    getAllNamespacesSuccess,
    getAllNamespacesFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAllNamespaces = (config?: GetAllNamespaces$Config) => {
    return {
        CALL_API: {
            types: getAllNamespacesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/entitlements/namespaces`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

